import React, { Component } from "react";
import { withRouter } from "react-router-dom";
import moment from "moment";
import BounceLoader from "react-spinners/BounceLoader";
import LoadingOverlay from "../../common/Loader";
import IdleTimer from "../../common/IdleTimer";
import Toaster from "../../components/Toaster";
import Header from "../../common/header";
import Footer from "../../common/footer";
import Sidebar from "../../common/sidebar";

import DateRangePicker from "react-bootstrap-daterangepicker";
import "bootstrap-daterangepicker/daterangepicker.css";

import { api } from "../../Services/index";
import { axiosClient, config } from "./../../Services/Config";
// var apiConfig = require('../../Services/constant.json')[process.env.REACT_APP_ENV || 'dev'];

//html editor
import { Editor } from "react-draft-wysiwyg";
import "react-draft-wysiwyg/dist/react-draft-wysiwyg.css";
import { EditorState, convertToRaw, ContentState } from "draft-js";
import draftToHtml from "draftjs-to-html";
import htmlToDraft from "html-to-draftjs";

import SweetAlert from "react-bootstrap-sweetalert";
import getRefreshToken from "../../Services/token";

const loaderStyle = {
  color: "#f3f3f3",
};

class FaqList extends Component {
  constructor(props, context) {
    super(props, context);
    this.state = {
      tab: 6,
      faqData: [],
      deleteFaqData: null,
      spinnerColor: "#000000",
      spinnerLoading: false,
      userLoggedIn: false,
      loginname: null,
      userloginid: null,
      editorState: EditorState.createEmpty(),
      toasterMessage: "",
      toasterType: "",
      showResultGrid: true,

      showDeleteFaqAlert: false,
    };
  }

  componentDidMount() {
    this.setUserInfo();
  }

  tabchangeevent = (e) => {
    this.setState({ tab: e });
  };

  setUserInfo = () => {
    this.state.userinfo = JSON.parse(localStorage.getItem("userinfo"));
    if (this.state.userinfo) {
      this.setState(
        {
          loginname: this.state.userinfo.roleinfo.loginname,
          userloginid: this.state.userinfo.roleinfo.userloginid,
          userLoggedIn: true,
        },
        () => {
          this.getFaqData(this.state.loginname);
        },
      );
    } else {
       localStorage.removeItem("userinfo");
this.props.history.push("/login");
      // return;
    }
  };

  getFaqData(userId) {
    try {
      this.setState({ spinnerLoading: true });
      api
        .getFaqData(userId)
        .then((data) => {
          if (data && data.response && data.response.status == 401) {
            this.getfaqrefreshtoken(userId);
          } else {
            this.setState({
              faqData: data.data.faqs,
              spinnerLoading: false,
            });
          }
        })
        .catch((error) => {
          console.log("faq data load Error : " + error);
          this.setState({
            spinnerLoading: false,
          });
          this.toggleToaster(
            "Failed to retrieve data from the API. Please try again later.",
            "error",
          );
        });
    } catch (e) {}
  }

  getrefreshtoken(userId) {
    getRefreshToken()
      .then((res) => {
        api
          .getFaqData(userId)
          .then((data) => {
            this.setState({
              faqData: data.data.faqs,
              spinnerLoading: false,
            });
          })
          .catch((error) => {
            console.log("faq data load Error : " + error);
          });
      })
      .catch((err) => {
         localStorage.removeItem("userinfo");
this.props.history.push("/login");
      });
  }

  viewFAQ = (faq_id, e) => {
    e.preventDefault();
    this.props.history.push({
      pathname: "/faq",
      state: {
        faq_id: faq_id,
        mode: "edit",
      },
    });
  };

  addFAQ = () => {
    this.props.history.push({
      pathname: "/faq",
      state: {
        faq_id: 0,
        mode: "add",
      },
    });
  };

  formatAnswerText = (txt) => {
    return txt.length > 100 ? `${txt.substring(0, 100)}...` : txt;
  };

  deleteFaq = (faq_id) => {
    this.getIndividualFaqData(faq_id);
  };

  deleteFaqConfirm = () => {
    this.publishDeletedFAQ();
  };

  onCancelDeleteFaq = () => {
    this.setState({
      showDeleteFaqAlert: false,
    });
  };

  getIndividualFaqData(faqId) {
    try {
      this.setState({ spinnerLoading: true });
      api
        .getIndFaqData(faqId)
        .then((data) => {
          if (data && data.response && data.response.status == 401) {
            this.getfaqrefreshtoken(userId);
          } else {
            this.setState({
              deleteFaqData: data.data,
              spinnerLoading: false,
              showDeleteFaqAlert: true,
            });
          }
        })
        .catch((error) => {
          console.log("faq data load Error : " + error);
          this.setState({
            spinnerLoading: false,
          });
          this.toggleToaster(
            "Failed to retrieve data from the API. Please try again later.",
            "error",
          );
        });
    } catch (e) {}
  }
  toggleToaster(message, type) {
    this.setState({
      toasterMessage: message,
      toasterType: type,
    });

    setTimeout(() => {
      this.setState({
        toasterMessage: null,
        toasterType: undefined,
      });
    }, 4000);
  }
  getfaqrefreshtoken(faqId) {
    getRefreshToken()
      .then((res) => {
        api
          .getIndFaqData(faqId)
          .then((data) => {
            this.setState({
              deleteFaqData: data.data,
              spinnerLoading: false,
              showDeleteFaqAlert: true,
            });
          })
          .catch((error) => {
            console.log("faq data load Error : " + error);
          });
      })
      .catch((err) => {
         localStorage.removeItem("userinfo");
this.props.history.push("/login");
      });
  }

  publishDeletedFAQ = () => {
    try {
      var arrFaqs = [];

      var ind_faqs = {
        faq_id: this.state.deleteFaqData.faq_id,
        question_text: this.state.deleteFaqData.question_text,
        answer_text: this.state.deleteFaqData.answer_text,
        is_update: false,
        is_delete: true,
      };

      arrFaqs.push(ind_faqs);
      var publishObj = { salesrepname: this.state.loginname, faqs: arrFaqs };

      api
        .publishFAQ(publishObj)
        .then((data) => {
          this.setState((prevState) => ({
            showDeleteFaqAlert: false,
          }));
          this.getFaqData(this.state.loginname);
        })
        .catch((error) => {
          console.log("Error : " + error);
        });
    } catch (e) {}
  };

  renderTableHeader() {
    var header = [];
    header = this.state.faqData[0] && Object.keys(this.state.faqData[0]);
    return (
      <tr key="tabheader">
        {this.state.userinfo &&
          this.state.userinfo.roleinfo.tasks.indexOf("DCGManageGlobalItems") !=
            -1 && <th style={{ width: "66px" }}>FAQ Id</th>}
        <th>Question</th>
        <th>Answer</th>
        {this.state.userinfo &&
          this.state.userinfo.roleinfo.tasks.indexOf("DCGManageGlobalItems") !=
            -1 && <th>Action</th>}
      </tr>
    );
  }

  renderTableData() {
    return (
      this.state.faqData &&
      this.state.faqData.map((data, index) => {
        const { faq_id, question_text, answer_text } = data;
        return (
          <tr class={question_text == "Total" ? "total" : ""} key={index}>
            {this.state.userinfo &&
              this.state.userinfo.roleinfo.tasks.indexOf(
                "DCGManageGlobalItems",
              ) != -1 && <td>{faq_id}</td>}
            {/* <td>{(question_text === null) ? 'NA' : question_text}</td> */}
            <td>
              {question_text === null ? (
                "NA"
              ) : this.state.userinfo &&
                this.state.userinfo.roleinfo.tasks.indexOf(
                  "DCGManageGlobalItems",
                ) != -1 ? (
                <a
                  href="javascript:void(0);"
                  onClick={(e) => this.viewFAQ(faq_id, e)}
                >
                  {" "}
                  {question_text}{" "}
                </a>
              ) : (
                question_text
              )}
            </td>
            <td>
              {answer_text === null
                ? "NA"
                : this.state.userinfo &&
                    this.state.userinfo.roleinfo.tasks.indexOf(
                      "DCGManageGlobalItems",
                    ) != -1
                  ? this.formatAnswerText(answer_text.replace(/<[^>]+>/g, ""))
                  : answer_text.replace(/<[^>]+>/g, "")}
            </td>
            {/* <td>{(answer_text === null) ? 'NA' : answer_text.replace(/<[^>]+>/g, '')}</td> */}
            {/* <td>{(answer_text === null) ? 'NA' : (answer_text.length > 100 ? `${answer_text.substring(0, 100)}...` : answer_text)}</td> */}
            {this.state.userinfo &&
              this.state.userinfo.roleinfo.tasks.indexOf(
                "DCGManageGlobalItems",
              ) != -1 && (
                <td>
                  <a
                    href="javascript:void(0);"
                    onClick={() => this.deleteFaq(faq_id)}
                    style={{ color: "red" }}
                  >
                    <i class="far fa-trash-alt"></i>
                  </a>
                </td>
              )}
          </tr>
        );
      })
    );
  }

  renderTable() {
    return (
      <div class="faqListPage">
        <table class="table table-bordered table-striped" id="table-data">
          <tbody>
            {this.renderTableHeader()}
            {this.renderTableData()}
          </tbody>
        </table>
      </div>
    );
  }

  render() {
    return (
      <div className="wrapper">
        <LoadingOverlay
          active={this.state.spinnerLoading}
          spinner={<BounceLoader />}
          className={loaderStyle}
        >
          {this.state.toasterMessage ? (
            <Toaster
              message={this.state.toasterMessage}
              toasterType={this.state.toasterType}
            />
          ) : null}
          <Header />
          <Sidebar tab={this.state.tab} tabchangeevent={this.tabchangeevent} />
          <IdleTimer></IdleTimer>
          <div className="content-wrapper pb-4">
            {this.state.showResultGrid === true && (
              <section class="content">
                <div class="container-fluid">
                  <div class="row">
                    <div class="col-md-12">
                      <h5>FAQ List</h5>
                      <hr />
                    </div>
                  </div>

                  <div class="row">
                    <div class="col-md-2"></div>
                    <div class="col-md-2"></div>
                    <div class="col-md-2"></div>
                    <div class="col-md-4"></div>
                    <div class="col-md-2 text-right">
                      {this.state.userinfo &&
                        this.state.userinfo.roleinfo.tasks.indexOf(
                          "DCGManageGlobalItems",
                        ) != -1 && (
                          <a
                            href="#"
                            onClick={this.addFAQ}
                            class="btn btn-primary"
                          >
                            <i class="fas fa-plus"></i> Add
                          </a>
                        )}
                    </div>
                  </div>

                  <div class="row">
                    <div class="col-md-12">
                      {/* <hr /> */}
                      <br></br>
                    </div>
                  </div>

                  <div class="row">
                    {!(Object.entries(this.state.faqData).length === 0) && (
                      <div class="col-md-12">{this.renderTable()}</div>
                    )}
                    {Object.entries(this.state.faqData).length === 0 && (
                      <div class="col-md-12">Sorry, No Records found!</div>
                    )}
                  </div>
                </div>
              </section>
            )}

            {this.state.showDeleteFaqAlert && (
              <SweetAlert
                showCancel
                confirmBtnText="Yes, delete!"
                style={{ color: "#000000", fontSize: "11px", minWidth: "30%" }}
                title="Are you sure to delete FAQ?"
                onConfirm={this.deleteFaqConfirm}
                onCancel={this.onCancelDeleteFaq}
                focusCancelBtn={true}
                closeOnClickOutside={true}
                allowEscape={true}
                btnSize={"sm"}
              >
                <span style={{ color: "#000000", fontSize: "12px" }}>
                  You will not be able to recover this FAQ!
                </span>
              </SweetAlert>
            )}
          </div>
        </LoadingOverlay>

        <Footer />
        <aside className="control-sidebar control-sidebar-dark"></aside>
      </div>
    );
  }
}
export default withRouter(FaqList);
